const ITEMS = [
  "Projeto Arquitetônico",
  "Estrutural",
  "Elétrico",
  "Hidrossanitário",
  "RRT / ART",
  "Memorial Descritivo",
  "Aprovação em Prefeitura",
  "Terra Roxa — Paraná",
];

export const MarqueeTicker = () => (
  <div className="overflow-hidden border-y border-slate-900/10 bg-white py-5" aria-hidden="true">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="px-8 font-display text-sm font-semibold uppercase tracking-[0.3em] text-slate-400">
                {item}
              </span>
              <span className="text-[#C05621]">+</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
